import moment from 'moment';

import Vue from 'vue';
import Vuex from 'vuex';

import question from './modules/question';
import client from './modules/client';

Vue.prototype.moment = moment;

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    question,
    client,
  },
});
